import { type ApiResponse } from "@fysaro/domain";
export function unwrap<T>(response: ApiResponse<T>): T {
  if (!response.success) {
    // Esto disparará el catch del hook o el onError de React Query
    const error: any = new Error(response.error.message);
    
    // Le colgamos las propiedades extra
    error.code = response.error.code;
    error.data = response.error.data; // Aquí­ es donde viaja el Diff
    error.status = (response as any).status; // Por si quieres el status HTTP

    throw error;
     
    //throw new Error(response.error.message);
  }
  return response.data;
}